import { useState } from "react";
import { startCheckoutSession, type CheckoutOfferKey } from "../integrations/stripe-checkout";

type Props = {
  offerKey: CheckoutOfferKey;
  className?: string;
  children: React.ReactNode;
};

/**
 * Starts Stripe Checkout via same-origin /api (proxied to Express in dev).
 */
export function CheckoutButton({ offerKey, className, children }: Props) {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  return (
    <div>
      <button
        type="button"
        disabled={loading}
        onClick={async () => {
          setError(null);
          setLoading(true);
          try {
            await startCheckoutSession(offerKey);
          } catch (e) {
            setError(e instanceof Error ? e.message : "Checkout failed");
          } finally {
            setLoading(false);
          }
        }}
        className={
          className ||
          "block w-full rounded-lg bg-signal-amber py-3 text-center text-sm font-semibold text-deck-deep hover:bg-amber-300 disabled:opacity-60"
        }
      >
        {loading ? "Redirecting…" : children}
      </button>
      {error && <p className="mt-2 text-xs text-red-400">{error}</p>}
      <p className="mt-2 text-xs text-slate-600">
        Tip: set <code className="text-signal-sky">STRIPE_SECRET_KEY</code> and{" "}
        <code className="text-signal-sky">STRIPE_PRICE_OFFER_*</code> in <code>.env</code> (see <code>.env.example</code>).
      </p>
    </div>
  );
}
